<template>
    <div>
        <section class="q10__jumbotron">
            <image-with-descriptions
                class="mb-8 mt-0"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.oImage1.src,
                    descriptions: [
                        {
                            text: currentPage.images.oImage1.alt,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                        {
                            text: currentPage.images.oImage1.text,
                            position: 'bottom-left', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
        </section>
        <div class="page">
            <div class="container px-11 2xl:px-3 mb-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-sushi',
                        to: 'to-golden_sand',
                    }"
                >
                    <h1 v-html="currentPage.content.sArticleTitle.text"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.sArticleDescription.text"
                ></p>

                <div class="container-components mb-8">
                    <TitleParagraph
                        :options="{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }"
                    >
                        <p
                            class="text-xl lg:text-2xl 2xl:text-4xl"
                            v-html="currentPage.content.sSubTitleOne.text"
                        ></p>
                    </TitleParagraph>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphOne_Title.text
                                "
                            ></span>
                        </TitleParagraph>
                        <span
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphOne_Content_01.text
                            "
                        ></span>
                        <router-link class="text-lg"
                                :to="{
                                    name: 'catalogue',
                                    params: { slug: 'page-033' },
                                }"
                                v-html="
                                    currentPage.content
                                        .sParagraphOne_Content_03.text
                                "
                            ></router-link>
                            <span
                                class="text-nandor 2xl:text-lg"
                                v-html="
                                    currentPage.content
                                        .sParagraphOne_Content_02.text
                                "
                            >
                            </span>
                        <div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage2.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage2
                                                .alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphTwo_Title.text
                                "
                            ></span>
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'top',
                                }"
                            />
                        </TitleParagraph>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphTwo_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card">
                        

                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphThree_Title
                                        .text
                                "
                            ></span>
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphThree_Content
                                        .text
                                "
                            >
                            </span>
                            <!-- <Dots
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                }"
                            /> -->
                        </paragraph>
                        <div class="relative">
                            
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Amélioration de la performance des groupes de Sisteron (2008 - 2014)'
                                    ),
                                }"
                                class="top-2 right-2"
                            />
                      
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage3.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage3
                                                .alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.oImage3
                                                .text,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="break-inside-avoid">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <p
                                class="text-xl lg:text-2xl 2xl:text-4xl"
                                v-html="currentPage.content.sSubTitleTwo.text"
                            ></p>
                        </TitleParagraph>
                        <div class="card">
                            <TitleParagraph
                                :options="{
                                    from: 'from-sushi',
                                    to: 'to-golden_sand',
                                }"
                            >
                                <!-- <Dots
                                    :options="{
                                        colors: [
                                            '#81C341',
                                            '#B7DD92',
                                            '#cce5a4',
                                        ],
                                    }"
                                /> -->
                                <span
                                    v-html="
                                        currentPage.content.sParagraphFour_Title
                                            .text
                                    "
                                ></span>
                                <Triangles
                                    :options="{
                                        colors: [
                                            '#81C341',
                                            '#B7DD92',
                                            '#cce5a4',
                                        ],
                                        direction: 'bottom',
                                    }"
                                />
                            </TitleParagraph>
                            <paragraph
                                :options="{
                                    color: 'text-nandor',
                                }"
                            >
                                <span
                                    v-html="
                                        currentPage.content
                                            .sParagraphFour_Content.text
                                    "
                                ></span>
                            </paragraph>
                            <div>
                                <image-with-descriptions
                                    :options="{
                                        image:
                                            'pages/' +
                                            currentPage.slug +
                                            '/' +
                                            currentPage.images.oImage4.src,
                                        descriptions: [
                                            {
                                                text: currentPage.images.oImage4
                                                    .alt,
                                                position: 'bottom-right', // top/bottom-left/right
                                                orientation: 'horizontal', // vertical, horizontal
                                            },
                                        ],
                                    }"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="relative pt-10">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Remise en service de la Centrale d’Enguri en Géorgie, témoignage de L. Terme'
                                    ),
                                }"
                                class="top-2 right-2"
                            />
                        </div>

                        <article-note
                            :options="{
                                verticalcontent:
                                    currentPage.content.sParagraphFive_Title
                                        .text,
                                content:
                                    currentPage.content.sParagraphFive_Quote
                                        .text,
                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-3xl',
                                    content: '',
                                },
                                margin: {},
                            }"
                        />
                        <div class="mt-4">
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage5.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage5
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphSix_Title.text
                                "
                            >
                            </span>
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'top',
                                }"
                            />
                        </TitleParagraph>

                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphSix_Content
                                        .text
                                "
                            >
                            </span>
                        </paragraph>
                        <div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage6.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage6
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="card break-inside-avoid">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                            class="flex"
                        >
                            <span 
                                v-html="
                                    currentPage.content.sParagraphSeven_Title
                                        .text
                                "
                            >
                            </span>
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'top',
                                }"
                            />
                        </TitleParagraph>

                        <p class="text-nandor text-lg"
                            v-html="
                                currentPage.content.sParagraphSeven_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card">
                        <article-note style="overflow: visible;"
                            :options="{
                                verticalcontent:
                                    currentPage.content.sParagraphEight_Title
                                        .text,
                                content:
                                    currentPage.content.sParagraphEight_Quote
                                        .text,
                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-4xl 2xl:text-3xl',
                                    content: '',
                                },
                                margin: {},
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage7.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage7.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>

                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphNine_Title
                                        .text
                                "
                            ></span>
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphNine_Content
                                        .text
                                "
                            ></span>
                        </paragraph>
                        <div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage8.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage8
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphTen_Title.text
                                "
                            ></span>
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphTen_Content
                                        .text
                                "
                            ></span>
                        </paragraph>
                        <div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage9.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage9
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphEleven_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphEleven_Content
                                        .text
                                "
                            ></span>
                            <!-- <Square
                                :options="{
                                    from: 'from-feijoa',
                                    to: 'to-selective_green',
                                }"
                            /> -->
                        </paragraph>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name : "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
</style>
